export default __webpack_public_path__ + "static/media/short.c75b3ee9.svg";